export const ACCOUNT_PACKAGES = [
  {
    id: 1,
    name: "TP100",
    price: 100,
    getFund8: 100,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: true
  },
  {
    id: 2,
    name: "TP250",
    price: 250,
    getFund8: 250,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: true
  },
  {
    id: 3,
    name: "TP500",
    price: 500,
    getFund8: 500,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: true
  },
  {
    id: 4,
    name: "TP1000",
    price: 1000,
    getFund8: 1000,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: true
  },
  {
    id: 5,
    name: "TP5000",
    price: 5000,
    getFund8: 5000,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: false
  },
  {
    id: 6,
    name: "TP10000",
    price: 10000,
    getFund8: 10000,
    drawdownLimit: "7%",
    profitRatio: "50/50",
    monthlyMinTarget: "5%",
    isActive: false
  }
];

export const getActivePackages = () => ACCOUNT_PACKAGES.filter(pkg => pkg.isActive);

export const getPackageById = (id) => ACCOUNT_PACKAGES.find(pkg => pkg.id === id);





